/**/
// const urlPrefix = 'http://app-prod-03.implicit.harvard.edu/openserver'; // first pathname section with slashes

// const urlPrefix = window.location.origin; // first pathname section with slashes

const urlPrefix = '..';//location.pathname.match(/^(?=\/)(.+?\/|$)/)[1]; // first pathname section with slashes


// console.log(location.href);
export const baseUrl            = `${urlPrefix}`;
export const studyUrl           = `${urlPrefix}/studies`;
export const launchUrl          = `${urlPrefix}/launch`;
export const templatesUrl       = `${urlPrefix}/templates`;
export const tagsUrl            = `${urlPrefix}/tags`;
export const translateUrl       = `${urlPrefix}/translate`;
export const poolUrl            = `${urlPrefix}/StudyData`;
export const statisticsUrl      = `${urlPrefix}/PITracking`;
export const downloadsUrl       = `${urlPrefix}/DashboardData`;
export const activationUrl      = `${urlPrefix}/activation`;
export const collaborationUrl   = `${urlPrefix}/collaboration`;
export const downloadsAccessUrl = `${urlPrefix}/DownloadsAccess`;
